export default __webpack_public_path__ + "static/media/succulent2-big.b3132d00.jpg";